import { render, staticRenderFns } from "./aboutme.vue?vue&type=template&id=0f30110e&scoped=true&"
import script from "./aboutme.vue?vue&type=script&lang=js&"
export * from "./aboutme.vue?vue&type=script&lang=js&"
import style0 from "./aboutme.vue?vue&type=style&index=0&id=0f30110e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f30110e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
